import { api } from "@/shared/api/client";
import { unwrap } from "@/shared/api/unwrap";
import { PROJECT_KEY } from "@/shared/lib/constants";
import { createLogger } from "@/shared/lib/logger";
import type {
  RegisterRequest,
  LoginRequest,
  AuthResponse,
  RefreshResponse,
  MeResponse,
  LogoutRequest,
} from "./types";

const log = createLogger("AUTH_API");

// ============================================================
// Public (no auth)
// ============================================================

export async function register(data: RegisterRequest): Promise<{ id: number }> {
  log.info("Register request", { login: data.login });
  return unwrap<{ id: number }>(
    api.post("api/auth/register", { json: { ...data, projectKey: PROJECT_KEY } }).json(),
  );
}

export async function login(data: LoginRequest): Promise<AuthResponse> {
  log.info("Login request", { login: data.login });
  return unwrap<AuthResponse>(
    api.post("api/auth/login", { json: { ...data, projectKey: PROJECT_KEY } }).json(),
  );
}

export async function refreshTokens(refreshToken: string): Promise<RefreshResponse> {
  log.debug("Refreshing tokens");
  return unwrap<RefreshResponse>(
    api.post("api/auth/refresh", { json: { refresh_token: refreshToken } }).json(),
  );
}

// ============================================================
// Protected (auto-injected Bearer token)
// ============================================================

export async function getMe(): Promise<MeResponse> {
  log.debug("Fetching /me");
  return unwrap<MeResponse>(api.get("api/auth/me").json());
}

export async function logout(data: LogoutRequest = {}): Promise<void> {
  log.info("Logout request");
  await api.post("api/auth/logout", { json: data });
}
